import { axiosClient } from "./axiosClient";
import { ApiVotingListItem } from "../types/votingsList";

// ── Hub „Odkrywaj" — publiczne, tylko dane za zgodą (profile profile_public, grupy public, głosowania public) ──

export type DiscoverProfile = {
  id: string;
  profile_ref: string;
  name: string;
  is_organization: boolean;
  avatar_url?: string | null;
  verified?: boolean | null;
  bio?: string | null;
  followers_count: number;
  followed_by_me?: boolean;
};

export type DiscoverGroup = {
  id: string;
  name: string;
  description?: string | null;
  avatar_url?: string | null;
  members_count: number;
  requires_approval?: boolean;
  signup_open?: boolean;
  is_member?: boolean;
};

export type JoinGroupStatus = "member" | "pending";

// Samodzielne dołączenie do publicznej grupy (zalogowany). Respektuje requires_approval.
export const joinDiscoverGroup = (groupId: string) =>
  axiosClient.post<{ status: JoinGroupStatus }>(`discover/groups/${groupId}/join`);

export type DiscoverMeta = { page: number; total_pages: number; total_count: number };

export type DiscoverSort = "popular" | "new";

export const getDiscoverProfiles = (params: { q?: string; type?: "organization" | "user"; sort?: DiscoverSort; page?: number }) =>
  axiosClient.get<{ profiles: DiscoverProfile[]; meta: DiscoverMeta }>("discover/profiles", { params });

export const getDiscoverGroups = (params: { q?: string; sort?: DiscoverSort; page?: number }) =>
  axiosClient.get<{ groups: DiscoverGroup[]; meta: DiscoverMeta }>("discover/groups", { params });

export type DiscoverFeed = {
  following_votings: ApiVotingListItem[];
  trending_votings: ApiVotingListItem[];
  suggested_profiles: DiscoverProfile[];
  suggested_groups: DiscoverGroup[];
};

export const getDiscoverFeed = () => axiosClient.get<DiscoverFeed>("discover/feed");
